<template>
  <div class="navbar">
    <div class="navbar-left">
      <Hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="$store.dispatch('app/toggleSideBar')" />

      <Breadcrumb />
    </div>

    <div class="navbar-right">
      <template v-if="device !== 'mobile'">
        <Screenfull class="screenfull-container" />

        <el-divider direction="vertical" />
      </template>

      <TcDropdownTeam class="tc-dropdown-team" />

      <el-divider direction="vertical" />

      <TcDropdownAccount class="tc-dropdown-account-container" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import TcDropdownTeam from '@/components-tc/TcDropdownTeam/index.vue'
import TcDropdownAccount from '@/components-tc/TcDropdownAccount/index.vue'

export default {
  components: {
    TcDropdownAccount,
    TcDropdownTeam,
    Breadcrumb,
    Hamburger,
    Screenfull
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device'
    ])
  }
}
</script>

<style scoped lang="scss">
.navbar {
  height: 50px;
  padding: 10px 15px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .navbar-left {
    display: flex;
    align-items: center;
    grid-gap: 15px;

    .hamburger-container {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  .navbar-right {
    display: flex;
    align-items: center;
    grid-gap: 10px;

    .screenfull-container {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .tc-dropdown-team {
      cursor: pointer;
    }

    .tc-dropdown-account-container {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>
